export default function createCircularProgressPalette(theme, current, _base) {
    return {
        circularProgress: {
            progress: {
                strokeColor: current[500],
            },
            rail: {
                fillColor: current[50],
                strokeColor: current[50],
            },
        },
    };
}
//# sourceMappingURL=circular-progress.js.map